// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';
import { WorkflowAnswerOptionUserDefined } from './workflowAnswerOptionUserDefined';

/**
 * Serializer used to get Question fields to update WorkflowQuestion.
 * @see #/components/schemas/WorkflowQuestionnaireQuestionUserDefined - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface WorkflowQuestionnaireQuestionUserDefined {
    /**
     * The title of the Workflow-Item-Answer.
     *
     */
    title?: string | null;
    required?: boolean;
    /**
     * The description of the Workflow-Item-Answer.
     *
     */
    description?: string | null;
    /**
     * The type of Item Questionnaire.
     *
     */
    item_type: string;
    /**
     * The answer options of Workflow-Item-Answer.
     *
     */
    answer_options?: Array<WorkflowAnswerOptionUserDefined> | null;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for WorkflowQuestionnaireQuestionUserDefined
 */
export namespace WorkflowQuestionnaireQuestionUserDefined {
    /**
     * WorkflowQuestionnaireQuestionUserDefined Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The title of the Workflow-Item-Answer.
         * @type string (`dataFormat` is missing)
         */
        title?: string | null;
        required?: boolean;
        /**
         * The description of the Workflow-Item-Answer.
         * @type string (`dataFormat` is missing)
         */
        description?: string | null;
        /**
         * The type of Item Questionnaire.
         * @type string (`dataFormat` is missing)
         */
        itemType: string;
        /**
         * The answer options of Workflow-Item-Answer.
         * @type Array<WorkflowAnswerOptionUserDefined> (`dataFormat` is missing)
         */
        @Type(() => WorkflowAnswerOptionUserDefined.Model)
        answerOptions?: Array<WorkflowAnswerOptionUserDefined.Model> | null;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * WorkflowQuestionnaireQuestionUserDefined DTO
     * Transforms WorkflowQuestionnaireQuestionUserDefined model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend WorkflowQuestionnaireQuestionUserDefined model */
        static toModel(obj: WorkflowQuestionnaireQuestionUserDefined): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend WorkflowQuestionnaireQuestionUserDefined model */
        static toApi(obj: Model): WorkflowQuestionnaireQuestionUserDefined {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as WorkflowQuestionnaireQuestionUserDefined;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
